// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","container":"Ti8gRr-XehiIahrWCgiXY","sub-inputs":"_3tUlIEA_4Z029MjMK1U34c","inputs-container":"_1sU-l7RLM7voeuxkKnsGrW","input-wrapper":"_3EPPq-OF1yC95fhKQHF8Em","checkbox":"_3_H7GPDR3EKb5JY40EEN48","post-description":"_1t1UKGcTAawnbtNF2bpQmJ","inputs-wrapper":"_1LbPbmagxyAAWBVrtTZXl-","nav-buttons":"_6BkMILpqpo9n0hrhAte7E"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/InputStep.mod.css
// module id = 1718
// module chunks = 0